module.exports = __webpack_public_path__ + "static/img/example-img.ca378c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/example-img.png
// module id = /Yja
// module chunks = 215